<template>
    <span class="text-bold" v-if="personalBest">PB! 🙌</span>
</template>

<script>
export default {
    name: "PersonalBestLabel",
    props: {
        personalBest: {
            default: false,
            required: false
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Assets/components/Utility/Labels/PersonalBestLabel.vue